// src/components/guards/FormValidationGuard.tsx

import React from 'react';
import { useParams, Navigate } from 'react-router-dom';
import { LoadingSpinner } from '@guardian/shared-ui';
import { useFormValidationGuard } from '@/hooks/useFormValidationGuard';
import { FormNotFound } from '@/components/FormNotFound';

interface FormValidationGuardProps {
    children: React.ReactNode;
}

export const FormValidationGuard: React.FC<FormValidationGuardProps> = ({ children }) => {
    const { formId } = useParams();
    const { isValidating, isValid, isNotFound, isNetworkError } = useFormValidationGuard(formId);

    if (isValidating) {
        return (
            <div className="flex h-[50dvh] w-full items-center justify-center">
                <LoadingSpinner size="lg" />
            </div>
        );
    }

    if (isNotFound) {
        return <FormNotFound />;
    }

    if (isNetworkError) {
        return <Navigate to="/connection-error" replace />;
    }

    if (isValid) {
        return <>{children}</>;
    }

    // Fallback — should not reach here
    return null;
};
